// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, {useEffect, useRef} from 'react'
// import ApexCharts, {ApexOptions} from 'apexcharts'
// import {getCSSVariableValue} from '../../../assets/ts/_utils'
// import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'

// // type Props = {
// //   className: string
// //   chartColor: string
// //   chartHeight: string
// // }
// type Props = {
//   className: string
//   chartColor: string
//   chartHeight: string
//   title: string
//   subtitle: string
//   amount: string
// }

// const MixedWidget10C: React.FC<Props> = ({ className, chartColor, chartHeight, title, subtitle,amount }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const {mode} = useThemeMode()
//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight))
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }

//   useEffect(() => {
//     const chart = refreshChart()

//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [chartRef, mode])

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Body */}
//       <div className='card-body d-flex flex-column p-0'>
//         {/* begin::Stats */}
//         <div className='flex-grow-1 card-p pb-0'>
//           <div className='d-flex flex-stack flex-wrap'>
//             <div className='me-2'>
//               <a href='#' className='text-dark text-hover-primary fw-bold fs-3'>
//                 {title}
//               </a>

//               <div className='text-dark fs-7 fw-semibold'>{subtitle}</div>
//             </div>

//             <div className={`fw-bold fs-3 text-${chartColor}`}></div>
//           </div>
//         </div>
//         {/* end::Stats */}

//         {/* begin::Chart */}
//         <div ref={chartRef} className='mixed-widget-7-chart card-rounded-bottom'></div>
//         {/* end::Chart */}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// const chartOptions = (chartColor: string, chartHeight: string): ApexOptions => {
//   const labelColor = getCSSVariableValue('--bs-gray-800')
//   const strokeColor = getCSSVariableValue('--bs-gray-300')
//   const baseColor = getCSSVariableValue('--bs-' + chartColor)
//   const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')

//   return {
//     series: [
//       {
//         name: 'Net Profit',
//         data: [15, 25, 15, 40, 20, 50],
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'area',
//       height: chartHeight,
//       toolbar: {
//         show: false,
//       },
//       zoom: {
//         enabled: false,
//       },
//       sparkline: {
//         enabled: true,
//       },
//     },
//     plotOptions: {},
//     legend: {
//       show: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     fill: {
//       type: 'solid',
//       opacity: 1,
//     },
//     stroke: {
//       curve: 'smooth',
//       show: true,
//       width: 3,
//       colors: [baseColor],
//     },
//     xaxis: {
//       categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//       crosshairs: {
//         show: false,
//         position: 'front',
//         stroke: {
//           color: strokeColor,
//           width: 1,
//           dashArray: 3,
//         },
//       },
//       tooltip: {
//         enabled: false,
//       },
//     },
//     yaxis: {
//       min: 0,
//       max: 60,
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     states: {
//       normal: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       hover: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       active: {
//         allowMultipleDataPointsSelection: false,
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//     },
//     tooltip: {
//       style: {
//         fontSize: '12px',
//       },
//       y: {
//         formatter: function (val) {
//           return '$' + val + ' thousands'
//         },
//       },
//     },
//     colors: [lightColor],
//     markers: {
//       colors: [lightColor],
//       strokeColors: [baseColor],
//       strokeWidth: 3,
//     },
//   }
// }

// export { MixedWidget10C }




















































// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//   className: string
//   chartColor: string
//   chartHeight: string
//   title: string
//   subtitle: string
//   amount: string
//   chartData?: { [key: string]: number } // New prop for dynamic data
//   seriesName?: string // Optional series name
// }

// const MixedWidget10C: React.FC<Props> = ({
//   className,
//   chartColor,
//   chartHeight,
//   title,
//   subtitle,
//   amount,
//   chartData,
//   seriesName = 'Quantity'
// }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()

//   // Process chart data
//   const processedChartData = React.useMemo(() => {
//     if (!chartData) {
//       return {
//         categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
//         data: [15, 25, 15, 40, 20, 50]
//       }
//     }

//     const entries = Object.entries(chartData)
//     const categories = entries.map(([key]) => {
//       const date = new Date(key + '-01')
//       return date.toLocaleDateString('en-US', { month: 'short' })
//     })
//     const data = entries.map(([, value]) => Math.round(value * 100) / 100) // Round to 2 decimals

//     return { categories, data }
//   }, [chartData])

//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const chart = new ApexCharts(
//       chartRef.current,
//       chartOptions(chartColor, chartHeight, processedChartData, seriesName)
//     )
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }

//   useEffect(() => {
//     const chart = refreshChart()

//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [chartRef, mode, processedChartData])

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Body */}
//       <div className='card-body d-flex flex-column p-0'>
//         {/* begin::Stats */}
//         <div className='flex-grow-1 card-p pb-0'>
//           <div className='d-flex flex-stack flex-wrap'>
//             <div className='me-2'>
//               <a href='#' className='text-dark text-hover-primary fw-bold fs-3'>
//                 {title}
//               </a>
//               <div className='text-dark fs-7 fw-semibold'>{subtitle}</div>
//             </div>
//             <div className={`fw-bold fs-2 text-${chartColor}`}>{amount}</div>
//           </div>
//         </div>
//         {/* end::Stats */}

//         {/* begin::Chart */}
//         <div ref={chartRef} className='mixed-widget-7-chart card-rounded-bottom'></div>
//         {/* end::Chart */}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// const chartOptions = (
//   chartColor: string,
//   chartHeight: string,
//   processedData: { categories: string[], data: number[] },
//   seriesName: string
// ): ApexOptions => {
//   const labelColor = getCSSVariableValue('--bs-gray-800')
//   const strokeColor = getCSSVariableValue('--bs-gray-300')
//   const baseColor = getCSSVariableValue('--bs-' + chartColor)
//   const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')

//   // Calculate max value for y-axis
//   const maxValue = Math.max(...processedData.data)
//   const yAxisMax = Math.ceil(maxValue * 1.1) // Add 10% padding

//   return {
//     series: [
//       {
//         name: seriesName,
//         data: processedData.data,
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'area',
//       height: chartHeight,
//       toolbar: {
//         show: false,
//       },
//       zoom: {
//         enabled: false,
//       },
//       sparkline: {
//         enabled: true,
//       },
//     },
//     plotOptions: {},
//     legend: {
//       show: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     fill: {
//       type: 'solid',
//       opacity: 1,
//     },
//     stroke: {
//       curve: 'smooth',
//       show: true,
//       width: 3,
//       colors: [baseColor],
//     },
//     xaxis: {
//       categories: processedData.categories,
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//       crosshairs: {
//         show: false,
//         position: 'front',
//         stroke: {
//           color: strokeColor,
//           width: 1,
//           dashArray: 3,
//         },
//       },
//       tooltip: {
//         enabled: false,
//       },
//     },
//     yaxis: {
//       min: 0,
//       max: yAxisMax,
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     states: {
//       normal: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       hover: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       active: {
//         allowMultipleDataPointsSelection: false,
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//     },
//     tooltip: {
//       style: {
//         fontSize: '12px',
//       },
//       y: {
//         formatter: function (val) {
//           return val.toLocaleString()
//         },
//       },
//     },
//     colors: [lightColor],
//     markers: {
//       colors: [lightColor],
//       strokeColors: [baseColor],
//       strokeWidth: 3,
//     },
//   }
// }

// export { MixedWidget10C }





























// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//   className: string
//   chartColor: string
//   chartHeight: string
//   title: string
//   subtitle: string
//   amount: string
//   chartData?: { [key: string]: number }
//   seriesName?: string
//   lineColor?: string        // ✅ Custom stroke color
//   fillColor?: string        // ✅ Custom area fill color
// }

// const MixedWidget10C: React.FC<Props> = ({
//   className,
//   chartColor,
//   chartHeight,
//   title,
//   subtitle,
//   amount,
//   chartData,
//   seriesName = 'Quantity',
//   lineColor,
//   fillColor,
// }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()

//   // Process chart data
//   const processedChartData = React.useMemo(() => {
//     if (!chartData) {
//       return {
//         categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
//         data: [15, 25, 15, 40, 20, 50],
//       }
//     }

//     const entries = Object.entries(chartData)
//     const categories = entries.map(([key]) => {
//       const date = new Date(key + '-01')
//       return date.toLocaleDateString('en-US', { month: 'short' })
//     })
//     const data = entries.map(([, value]) => Math.round(value * 100) / 100)

//     return { categories, data }
//   }, [chartData])

//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const chart = new ApexCharts(
//       chartRef.current,
//       chartOptions(chartColor, chartHeight, processedChartData, seriesName, lineColor, fillColor)
//     )
//     chart.render()
//     return chart
//   }

//   useEffect(() => {
//     const chart = refreshChart()
//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//   }, [chartRef, mode, processedChartData, chartColor, chartHeight, seriesName, lineColor, fillColor])

//   return (
//     <div className={`card ${className}`}>
//       <div className='card-body d-flex flex-column p-0'>
//         <div className='flex-grow-1 card-p pb-0'>
//           <div className='d-flex flex-stack flex-wrap'>
//             <div className='me-2'>
//               <a href='#' className='text-dark text-hover-primary fw-bold fs-3'>
//                 {title}
//               </a>
//               <div className='text-dark fs-7 fw-semibold'>{subtitle}</div>
//             </div>
//             <div className={`fw-bold fs-2`} style={{ color: lineColor || `var(--bs-${chartColor})` }}>
//               {amount}
//             </div>
//           </div>
//         </div>

//         <div ref={chartRef} className='mixed-widget-7-chart card-rounded-bottom'></div>
//       </div>
//     </div>
//   )
// }

// const chartOptions = (
//   chartColor: string,
//   chartHeight: string,
//   processedData: { categories: string[]; data: number[] },
//   seriesName: string,
//   lineColor?: string,
//   fillColor?: string
// ): ApexOptions => {
//   const labelColor = getCSSVariableValue('--bs-gray-800')
//   const strokeColor = getCSSVariableValue('--bs-gray-300')

//   const defaultBaseColor = getCSSVariableValue('--bs-' + chartColor)
//   const defaultFillColor = getCSSVariableValue('--bs-' + chartColor + '-light')

//   const baseColor = lineColor || defaultBaseColor
//   const areaColor = fillColor || defaultFillColor

//   const maxValue = Math.max(...processedData.data)
//   const yAxisMax = Math.ceil(maxValue * 1.1)

//   return {
//     series: [
//       {
//         name: seriesName,
//         data: processedData.data,
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'area',
//       height: chartHeight,
//       toolbar: { show: false },
//       zoom: { enabled: false },
//       sparkline: { enabled: true },
//     },
//     legend: { show: false },
//     dataLabels: { enabled: false },
//     fill: {
//       type: 'solid',
//       opacity: 1,
//       colors: [areaColor],
//     },
//     stroke: {
//       curve: 'smooth',
//       show: true,
//       width: 3,
//       colors: [baseColor],
//     },
//     xaxis: {
//       categories: processedData.categories,
//       axisBorder: { show: false },
//       axisTicks: { show: false },
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//       crosshairs: {
//         show: false,
//         position: 'front',
//         stroke: {
//           color: strokeColor,
//           width: 1,
//           dashArray: 3,
//         },
//       },
//       tooltip: { enabled: false },
//     },
//     yaxis: {
//       min: 0,
//       max: yAxisMax,
//       labels: {
//         show: false,
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     tooltip: {
//       style: { fontSize: '12px' },
//       y: {
//         formatter: function (val) {
//           return val.toLocaleString()
//         },
//       },
//     },
//     colors: [areaColor],
//     markers: {
//       colors: [areaColor],
//       strokeColors: [baseColor],
//       strokeWidth: 3,
//     },
//   }
// }

// export { MixedWidget10C }









import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
  title: string
  subtitle: string
  amount: string
  chartData?: { [key: string]: number }
  seriesName?: string
  lineColor?: string
  fillColor?: string
}

const MixedWidget10C: React.FC<Props> = ({
  className,
  chartColor,
  chartHeight,
  title,
  subtitle,
  amount,
  chartData,
  seriesName = 'Quantity',
  lineColor,
  fillColor,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  // Process chart data - detect if yearly or monthly
  const processedChartData = React.useMemo(() => {
    if (!chartData) {
      return {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        data: [15, 25, 15, 40, 20, 50],
        isYearly: false,
      }
    }

    const entries = Object.entries(chartData)

    // Detect if data is yearly (YYYY) or monthly (YYYY-MM)
    const firstKey = entries[0]?.[0] || ''
    const isYearly = firstKey.length === 4 || !firstKey.includes('-')

    const categories = entries.map(([key]) => {
      if (isYearly) {
        // For yearly data, just return the year
        return key
      } else {
        // Check if full date (YYYY-MM-DD)
        const parts = key.split('-')
        if (parts.length === 3) {
          const date = new Date(key)
          // Return valid date format, e.g. "Oct 31"
          return isNaN(date.getTime()) ? key : date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' })
        } else {
          // For monthly data, format as month name
          const date = new Date(key + '-01')
          return isNaN(date.getTime()) ? key : date.toLocaleDateString('en-US', { month: 'short' })
        }
      }
    })

    const data = entries.map(([, value]) => Math.round(value * 100) / 100)

    return { categories, data, isYearly }
  }, [chartData])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(chartColor, chartHeight, processedChartData, seriesName, lineColor, fillColor)
    )
    chart.render()
    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, processedChartData, chartColor, chartHeight, seriesName, lineColor, fillColor])

  return (
    <div className={`card ${className}`}>
      <div className='card-body d-flex flex-column p-0'>
        <div className='flex-grow-1 card-p pb-0'>
          <div className='d-flex flex-stack flex-wrap'>
            <div className='me-2'>
              <a href='#' className='text-dark text-hover-primary fw-bold fs-3'>
                {title}
              </a>
              <div className='text-dark fs-7 fw-semibold'>{subtitle}</div>
            </div>
            <div className={`fw-bold fs-2`} style={{ color: lineColor || `var(--bs-${chartColor})` }}>
              {amount}
            </div>
          </div>
        </div>

        <div ref={chartRef} className='mixed-widget-7-chart card-rounded-bottom'></div>
      </div>
    </div>
  )
}

const chartOptions = (
  chartColor: string,
  chartHeight: string,
  processedData: { categories: string[]; data: number[]; isYearly: boolean },
  seriesName: string,
  lineColor?: string,
  fillColor?: string
): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-800')
  const strokeColor = getCSSVariableValue('--bs-gray-300')

  const defaultBaseColor = getCSSVariableValue('--bs-' + chartColor)
  const defaultFillColor = getCSSVariableValue('--bs-' + chartColor + '-light')

  const baseColor = lineColor || defaultBaseColor
  const areaColor = fillColor || defaultFillColor

  const maxValue = Math.max(...processedData.data)
  const yAxisMax = Math.ceil(maxValue * 1.1)

  return {
    series: [
      {
        name: seriesName,
        data: processedData.data,
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: chartHeight,
      toolbar: { show: false },
      zoom: { enabled: false },
      sparkline: { enabled: true },
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    fill: {
      type: 'solid',
      opacity: 1,
      colors: [areaColor],
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3,
      colors: [baseColor],
    },
    xaxis: {
      type: 'category',
      categories: processedData.categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        show: false,
        position: 'front',
        stroke: {
          color: strokeColor,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: { enabled: true }, // ✅ Enable to show x-axis label in tooltip
    },
    yaxis: {
      min: 0,
      max: yAxisMax,
      labels: {
        show: false,
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    tooltip: {
      style: { fontSize: '12px' },
      x: {
        show: true, // ✅ Show the category (year or month)
      },
      y: {
        formatter: function (val) {
          return val.toLocaleString()
        },
      },
    },
    colors: [areaColor],
    markers: {
      colors: [areaColor],
      strokeColors: [baseColor],
      strokeWidth: 3,
    },
  }
}

export { MixedWidget10C }